import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f7be16f6558f00141c5d0c/wbosorga/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f7be16f6558f00141c5d0c/wbosorga/src/app/components/HomeCollaborateurDoor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f7be16f6558f00141c5d0c/wbosorga/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f7be16f6558f00141c5d0c/wbosorga/src/components/ui/AppLogo.tsx");
